import React, { useContext } from 'react'
import "./Content.css"
import { Theme } from '../Theme'
import { FiSettings } from 'react-icons/fi'
import { RiChat1Line, RiToolsLine, RiChat3Line, RiTwitterFill, RiMailSettingsLine, RiSettingsLine, RiFolderSettingsFill, RiFileSettingsLine, RiListSettingsLine, RiUserSettingsLine } from 'react-icons/ri'
import { AiOutlineUsergroupAdd, AiOutlineLike, AiOutlineUserAdd, AiOutlineEdit, AiOutlineUserSwitch } from "react-icons/ai"
import { IoMdAnalytics, IoMdCash } from 'react-icons/io'
import Card from '../Components/Card/Card'
import Analytics from '../Components/Analytics/Analytics'
import Listhelp from '../Components/List/Listhelp'
import RevenueChart from '../Components/RevenueChart/Revenuechart.js';
import { FiArrowDownRight } from "react-icons/fi";  
import ProfitChart from '../Components/ProfitChart/ProfitChart.js'
import MapChart from '../Components/MapChart/MapChart.js'
import ClientTable from '../Components/ClientTable/ClientTable.js'
import { MdArrowOutward } from "react-icons/md";
import AccountabilityList from '../Components/AccountabilityList/AccountabilityList.js'
import ClientLocations from '../Components/ClientLocations/ClientLocations.js'
const Content = () => {
  const { DarkTheme } = useContext(Theme)
  return (
    <>
      <div className='content'>
        <div className="row header">
          <h1 className='t1'>Total Revenue  </h1>
          <h1 className='t2'>$36,0123 </h1>
          <div class="progress-container1">
            <div class="progress-bar1-1"></div>
          </div>
          <h1 className='t3'><MdArrowOutward></MdArrowOutward>  2.7 % in 1 month</h1>
        </div>
        <div className="row header">
        <h1 className='t1'>Calls Booked  </h1>
          <h1 className='t2a'>78 </h1>
          <div class="progress-container1">
            <div class="progress-bar1-2"></div>
          </div>
          <h1 className='t3'><MdArrowOutward></MdArrowOutward> 2.7 % in 1 month</h1>
        </div>
        <div className="row header">
        <h1 className='t1'>Hot Leads  </h1>
          <h1 className='t2a'>24 </h1>
          <div class="progress-container1">
            <div class="progress-bar1-3"></div>
          </div>
          <h1 className='t3d'><FiArrowDownRight></FiArrowDownRight> 2.7 % in 1 month</h1>
        </div>
        <div className="row header">
        <h1 className='t1'>Goal Target </h1>
          <h1 className='t2a'>86 </h1>
          <div class="progress-container1">
            <div class="progress-bar1-4"></div>
          </div>
          <h1 className='t3'><MdArrowOutward></MdArrowOutward> 2.7 % in 1 month</h1>
        </div>
      </div>
      <div className='content2'>
        <div className="square big">
  
        <RevenueChart></RevenueChart>
        </div>
        <div className="square small">
          <ProfitChart></ProfitChart>
        </div>
      </div>
      <div className='content2'>
        <div className="square bigg">
          <ClientLocations></ClientLocations>
        </div>
        <div className="square smalll">
          <AccountabilityList></AccountabilityList>
          {/* <Analytics chart_iv></Analytics> */}
        </div>
      </div>
      <ClientTable className='last'></ClientTable>
    </>

  )
}

export default Content
